import { Injectable, inject } from '@angular/core';
import { Resolve } from '@angular/router';
import { AuthInitService } from './auth.service';

@Injectable()
export class AuthInitResolverService implements Resolve<void> {
  private authInit = inject(AuthInitService);

  resolve(): void {
    /* empty */
  }
}
